module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"tabs flex flex-row\">\n	")
    ;  Util.each(widget.tabs, function (tab) {
	if (tab.accessKey && !check(tab.accessKey, Security.AccessMode.View)) return null;
    ; __append("\n		<div name=\"")
    ; __append(escapeFn( tab.name ))
    ; __append("\" class=\"tab ")
    ;  if (widget.currentTab && widget.currentTab.name == tab.name) { 
    ; __append("active")
    ;  } 
    ; __append(" flex flex-column\">")
    ; __append(escapeFn( tab.title ))
    ; __append("</div>\n	")
    ;  }) 
    ; __append("\n</div>\n<div class=\"tab-content flex\"></div>\n")
  }
  return __output.join("");

}